import '../../styles/Hero.css';
import { Link } from 'react-router-dom';
import campus from '../../images/campus.jpg';

function Hero() {
  return (
    <div className="hero-full" style={{ backgroundImage: `url(${campus})` }}>
      <div className="overlay">
        <div className="hero-text animate-fade-in">
          <h1>Welcome to Our<br />College</h1>
          <Link className="glow-button" to = "/about-us">Learn More</Link>
        </div>
      </div>

      {/* SVG Curve Divider */}
      <div className="curve-divider">
        <svg viewBox="0 0 1440 100" xmlns="http://www.w3.org/2000/svg">
          <path fill="#e6f4e6" d="M0,0 C720,100 720,0 1440,100 L1440,0 L0,0 Z" />
        </svg>
      </div>
    </div>
  );
}

export default Hero;
